import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
	List,
	Popup
} from 'semantic-ui-react';

import { log } from '../../../services/utils';

const PasswordInstructionsPopup = ( {
	context,
	open,
	password
} ) => {
	const setColor = regex => {
		if ( !password ) {
			return null;
		}

		return regex.test( password )
			? 'green'
			: 'red';
	};

	const setIcon = regex => {
		if ( !password ) {
			return 'circle outline';
		}

		return regex.test( password )
			? 'check circle outline'
			: 'times circle outline';
	};

	return (
		<Popup
			context={ context
				? context
				: null
			}
			inverted
			open={ open }
			position="top center"
			size="small"
			style={ { opacity: 0.95 } }
		>
			{ log( '- passwordInstructionsPopup' ) }
			<Popup.Content>
				<List>
					<List.Content>
						<List.Item>
							<List.Icon
								color={ setColor( /^.{8,}$/ ) }
								name={ setIcon( /^.{8,}$/ ) }
							/>
              &nbsp;
              At least 8 characters in length
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[A-Z]+.*)$/ ) }
								name={ setIcon( /(.*[A-Z]+.*)$/ ) }
							/>
              &nbsp;
              One uppercase letter
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[a-z]+.*)$/ ) }
								name={ setIcon( /(.*[a-z]+.*)$/ ) }
							/>
              &nbsp;
              One lowercase letter
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[0-9]+.*)$/ ) }
								name={ setIcon( /(.*[0-9]+.*)$/ ) }
							/>
              &nbsp;
              One numeric digit
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[`~!#$%^&*()_=+[\]{}\\|;:’“,<.>/?-]+.*)$/ ) }
								name={ setIcon( /(.*[`~!#$%^&*()_=+[\]{}\\|;:’“,<.>/?-]+.*)$/ ) }
							/>
              &nbsp;
              One special character
						</List.Item>
					</List.Content>
				</List>
			</Popup.Content>
		</Popup>
	);
};

PasswordInstructionsPopup.propTypes = {
	open: PropTypes.bool.isRequired,
	password: PropTypes.node.isRequired,
	context: PropTypes.object.isRequired
};

export default memo( PasswordInstructionsPopup );
